export const EMPTY_VALUE_REGEX = /^<[a-zA-Z0-9]+><br><\/[a-zA-Z0-9]+>$/g;

export const EDITOR_TOOLBAR_HEIGHT = 44;
export const EDITOR_HEIGHT = 400;
